// extracted by mini-css-extract-plugin
export default {"sr-only":"mupvw","skeleton-line":"cCfYL","shine":"bECkr","scroll-hidden":"h7ktk"};